<button mat-fab [color]="color" [disabled]="disabled || loading" [class.loading-container]="loading"
  [matBadge]="badge" [matBadgeHidden]="!badge" matBadgeOverlap="true" matBadgeColor="primary"
  [matTooltip]="tooltip" [matTooltipPosition]="tooltipPosition ? tooltipPosition : 'before'">
  @if (disabledDelay > 0 && disabled) {
    {{ disabledDelay }}
  } @else {
    <mat-icon>{{ icon }}</mat-icon>
  }
</button>
